<template>
	<MStateBox :loading="roadshow.loading" :empty="isEmpty" class="roadshow-content">
		<CMobileScroll pullDown @pull-down="onPullDown" pullUp :moreData="hasMoreData" @pull-up="onPullUp">
			<div class="roadshow-list">
				<div class="roadshow-box-item" v-for="item in finalData" :key="item.id" @click="handleClick(item)">
					<div class="roadshow-left-area">
						<img :src="item.logo43 || require('@/assets/images/empty_event_cover.png')" alt="" />
						<div class="roadshow-authtag" v-if="item.authtag">
							{{ item.authtag }}
						</div>
					</div>
					<div class="roadshow-right-area">
						<div class="roadshow-title text-overflow2">
							{{ item.title }}
						</div>
						<div class="roadshow-name">
							{{ item.createUserName }}
						</div>
						<div class="roadshow-bottom">
							<div
								class="roadshow-bottom-left"
								:class="{ 'status-notice': item.status === 0, 'status-live': item.status === 1 }"
							>
								<span class="roadshow-status" v-if="item.status === 0">
									<SvgIcons name="icon_yugao" class="research-icon" />
									{{ $t('enterprise.investment.preview') }}
								</span>
								<span class="roadshow-status" v-if="item.status === 1">
									<SvgIcons name="icon_live" class="research-icon" />
									{{ $t('enterprise.investment.live') }}
								</span>
								<span class="roadshow-status" v-if="item.status === 3">
									<SvgIcons name="icon_huifang" class="research-icon" />
									{{ $t('enterprise.investment.playback') }}
								</span>
								<div
									class="circle"
									:class="{
										'circle-status-notice': item.status === 0,
										'circle-status-live': item.status === 1
									}"
									v-if="item.status === 0 || item.status === 1 || item.status === 3"
								></div>
								<span class="organizer-time">{{
									dateFormatYearMonthDate(item.stime || item.ctime)
								}}</span>
							</div>
							<p class="browse-count" v-if="item.sourceType != 1">
								{{ item.browsecount }}{{ $t('enterprise.investment.views') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</CMobileScroll>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useCurrentReactive } from '../context';
import { usePaginationMobile } from '@rebuild/hooks/load-more/usePaginationMobile';
import MStateBox from '@rebuild/components/MStateBox.vue';

const { roadshow } = useModuleData();
const isEmpty = computed(() => {
	return finalData.value.length === 0 && !roadshow.loading;
});
const refreshRoadshow = async () => {
	await roadshow.refresh({
		pageStart: currentPage.value - 1,
		pageNum: pageSize.value
	});

	const data = roadshow.data?.data || [];
	const total = roadshow.data?.total || 0;
	setData(data, total);
};

onMounted(() => {
	refreshRoadshow();
});

const { currentPage, pageSize, finalData, setData, hasMoreData, onPullDown, onPullUp } = usePaginationMobile({
	bindChange: refreshRoadshow
});

const { viewRoadshow } = useCurrentReactive();
const handleClick = item => {
	return viewRoadshow(item);
};
</script>

<style lang="less" scoped>
.roadshow-content {
	padding: 0 16px;
	height: 100%;

	.roadshow-box-item {
		display: flex;
		padding: 12px 0;
		border-bottom: 1px solid var(--border-lighter-color, #f2f3f5);

		.roadshow-left-area {
			position: relative;
			height: 81px;
			width: 108px;
			border-radius: 2px;
			padding: 4px 0;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
			.roadshow-authtag {
				position: absolute;
				top: 8px;
				right: 4px;
				padding: 0 3px;
				border-radius: 1px;
				background: #f76a2b;
				color: #ffffff;
				font-size: 11px;
				line-height: 16px;
			}
		}
		.roadshow-right-area {
			flex: 1;
			margin-left: 10px;
			.roadshow-title {
				color: var(--t-emphasis-color, #1d2129);

				font-size: 15px;
				font-weight: 400;
				line-height: 24px; /* 160% */
			}
			.roadshow-name {
				margin-top: 10px;
				color: var(--t-secondary-info-color, #86909c);

				font-size: 11px;
				font-weight: 400;
				line-height: 16px; /* 145.455% */
			}
		}
		.roadshow-bottom {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 13px;
			height: 26px;

			.roadshow-bottom-left {
				display: flex;
				align-items: center;

				color: var(--t-secondary-info-color, #86909c);
				font-size: 11px;

				font-weight: 400;
				line-height: 16px;
				.circle {
					width: 3px;
					height: 3px;
					margin: 0 4px;
					border-radius: 50%;
					background-color: var(--t-secondary-info-color, #86909c);
				}

				.circle-status-notice {
					background-color: #3964e5;
				}
				.circle-status-live {
					background-color: #f23d3d;
				}
				.research-icon {
					float: left;
					margin-right: 2px;
					width: 16px;
					height: 16px;
				}
			}
			.status-notice {
				color: #3964e5;
			}
			.status-live {
				color: #f23d3d;
			}
			.browse-count {
				color: var(--t-secondary-info-color, #86909c);

				font-size: 11px;

				font-weight: 400;
				line-height: 16px; /* 145.455% */
			}
		}
	}
	.roadshow-box-item:first-child {
		padding-top: 4px;
	}
	.roadshow-box-item:last-child {
		border: none;
	}
}
</style>
